import { add, Dinero } from "dinero.js"
import { DeliveryTimesField } from "../../form/formTypes"
import { toDinero } from "../../../../../../modules/currency/currencyLib"

export function calculateTotalAmountFromDeliveries(
    deliveries: DeliveryTimesField,
    fallbackCurrency: string = "DKK",
): Dinero<number> {
    const defaultPrice = toDinero({ amount: 0, scale: 2, currency: fallbackCurrency })

    return deliveries.deliveryTimes.reduce((total: Dinero<number>, delivery) => {
        const deliveryTotal = delivery.orderLines.reduce((sum, p) => {
            return add(
                sum,
                p.price
                    ? toDinero({
                          amount: p.price.amount * p.quantity,
                          scale: p.price.scale,
                          currency: p.price.currency,
                      })
                    : defaultPrice,
            )
        }, defaultPrice)

        return add(total, deliveryTotal)
    }, defaultPrice)
}
